

























import {createComponent, ref, computed, watch} from '@vue/composition-api';
import {crossEnv} from '@sbvr/lbe-environment';
import {loginRequest, SSOLogin} from '@/core/actions/login';
import router from '@/core/routes';
import UIInput from '@sbvr/lbe-ui/UIInput.vue';
import UIButton from '@sbvr/lbe-ui/UIButton.vue';
import useFlashService from '@sbvr/lbe-web-panel/flash';
import i18n from '@/core/i18n';
import BaseLayout from './layouts/BaseLayout.vue';

export default createComponent({
  components: {
    BaseLayout,
    UIInput,
    UIButton,
  },
  props: {
    sso: {
      type: Boolean,
    },
  },
  setup(props) {
    const redirect = router.currentRoute.query.redirect;
    if (props.sso) {
      SSOLogin(redirect);
    }
    const email = ref('');
    const password = ref('');
    const hasSent = ref(false);
    const {showFlash} = useFlashService();
    watch(() => {
      return [email.value, password.value];
    }, () => {
      hasSent.value = false;
    });
    const panelUrl = window.sbvrenv.PANEL_URL;
    const publicUrl = window.sbvrenv.PUBLIC_URL;

    async function login() {
      hasSent.value = true;
      try {
        const response = await loginRequest({
          email: email.value,
          password: password.value,
        })

        if (router.currentRoute.query.redirectto) {
          let redirectTo = router.currentRoute.query.redirectto;
          if (typeof redirectTo === 'string' && redirectTo.includes('deployreality.com')) {
            createSessionToSendDeployReality(redirectTo, response);
            return;
          }
        }

        const redirectOnLoginUrl = response.redirectOnLoginUrl;
        if (props.sso) {
          const redirect = router.currentRoute.query.redirect;
          SSOLogin(redirect);
          return;
        }

        const redirectParams = router.currentRoute.query.redirect && (router.currentRoute.query.redirect as string).replace(/\/login$/, '');
        const redirectURL = crossEnv.ENV !== 'production' ? redirectParams : redirectParams && redirectParams.match(redirectOnLoginUrl) && redirectParams;
        window.location.href = redirectURL || redirectOnLoginUrl || `https://${crossEnv.OPERATOR_URL}`;
      } catch (e) {
        hasSent.value = false;
        if (e.response && e.response.status > 499) {
          showFlash({
            type: 'error',
            render(h) {
              return h('i18n', {
                props: {path: 'SpringboardVR may be experiencing some issues. Check out our {link}'},
              }, [
                h(UIButton, {
                  attrs: {
                    link: true,
                    href: 'https://status.springboardvr.com',
                    rel: 'noopener',
                    target: '_blank',
                  },
                  slot: 'link',
                }, i18n.t('status page') as string),
              ]);
            },
          });
          return;
        }
        throw e;
      }
    }

    /**
     * Create a session to send to deployreality.com and redirect to it
     * @param baseUrl
     * @param data
     */
    async function createSessionToSendDeployReality(baseUrl: string, data: any) {
      let gameIds = '';
      let locationIds = '';
      let role = '';
      if (data.organization?.games?.length > 0) {
        gameIds = data.organization.games
          .filter(game => game.preset !== null && game.preset !== undefined)
          .map(game => game.preset.originalId).join(',');
      }

      if (data.organization?.locations?.length > 0) {
         locationIds = data.organization.locations.map((location: any) => location.originalId).join(',');
      }

      role = 'admin';
      if(data.organization !== null && data.organization !== undefined){
          if(data.organization.type === 'developer'){
            role = 'producer';
          } else {
            role = 'arcadeowner';
          }
      }

      const payload = {
        game_ids: gameIds || '',
        arcade_ids: locationIds || '',
        source: 'sbvr',
        sbvracctid: data.originalId,
        mycountry: (data.organization?.state?.length > 0 ? 'US' : data.organization?.country) || 'US',
        name: data.name,
        role: role
      };

      const keyString = 'Y[CmG}M@"d){ZFic';
      const encoder = new TextEncoder();
      const iv = crypto.getRandomValues(new Uint8Array(12));
      const keyMaterial = await crypto.subtle.importKey(
        'raw',
        encoder.encode(keyString),
        'PBKDF2',
        false,
        ['deriveKey']
      );

      const key = await crypto.subtle.deriveKey(
        {
          name: 'PBKDF2',
          salt: encoder.encode('deployreality'),
          iterations: 100000,
          hash: 'SHA-256',
        },
        keyMaterial,
        {
          name: 'AES-GCM',
          length: 256,
        },
        false,
        ['encrypt']
      );

      const encryptedBuffer = await crypto.subtle.encrypt(
        {
          name: 'AES-GCM',
          iv: iv,
        },
        key,
        encoder.encode(JSON.stringify(payload))
      );

      const combined = new Uint8Array(iv.length + encryptedBuffer.byteLength);
      combined.set(iv, 0);
      combined.set(new Uint8Array(encryptedBuffer), iv.length);

      const encryptedBase64 = btoa(String.fromCharCode(...combined));

      window.location.href = `${baseUrl}?session=${btoa(JSON.stringify({
        source: "sbvr",
        session: encryptedBase64
      }))}`;
    }


    const forgotPwdLink = computed(() => ({
      name: 'password-reset',
      query: {
        email: email.value || undefined,
      },
    }));
    return {
      email,
      password,
      panelUrl,
      publicUrl,
      login,
      forgotPwdLink,
      hasSent,
    };
  },
});

